import Vue from 'vue'
import moment from 'moment-timezone'
// import 'moment-timezone'

moment.locale('ja')
moment().tz('Asia/Tokyo')

Object.defineProperty(Vue.prototype, '$moment', { value: moment })